<template>
  <div
    class="login-container"
    :class="{
      'login-container__web': !isElectron && !isH5,
      'login-container__h5': isH5,
    }"
  >
    <div class="logo-container" v-if="isElectron">
      <div class="logo-box">
        <img class="login-main" :src="loginImgUrl" alt="logo" />
        <img class="login-logo" :src="logoUrl" alt="" />
      </div>
    </div>
    <div class="input-container">
      <input-account
        v-if="step === 'InputAccount'"
        :inputType="inputAccountType"
        class="input-account"
        @sendCodeSuccess="sendCodeSuccess"
        @goBindAccount="goBindAccount"
        @goSelectIdentity="goSelectIdentity"
      />
      <input-code
        v-if="step === 'InputCode'"
        class="input-account"
        :type="inputCodeType"
        @switchPasswordLogin="changeLoginType"
        @accountNotExist="goSetPassword"
        @back="goBack"
        @codeError="goBack"
        @goSelectIdentity="goSelectIdentity"
      />
      <input-password
        v-if="step === 'InputPassword'"
        class="input-account"
        @switchPasswordLogin="changeLoginType"
        @back="goBack"
        @accountExist="goLogin"
        @goSelectIdentity="goSelectIdentity"
      />
      <bind-account
        v-if="step === 'BindAccount'"
        class="input-account"
        @sendCodeSuccess="sendCodeSuccess"
        @back="goInputAccount('QR')"
      ></bind-account>
      <select-identity
        v-if="step === 'SelectIdentity'"
        class="input-account"
        @back="goBack"
      ></select-identity>
    </div>
  </div>
</template>

<script>
import InputAccount from "./components/InputAccount";
import InputCode from "./components/InputCode";
import InputPassword from "./components/InputPassword";
import BindAccount from "./components/BindAccount";
import SelectIdentity from "./components/SelectIdentity";
import { isH5 } from "@saas/components/src";
export default {
  name: "LoginPage",
  components: {
    InputAccount,
    InputCode,
    InputPassword,
    BindAccount,
    SelectIdentity,
  },
  data() {
    return {
      step: "InputAccount",
      loginType: "",
      inputCodeType: "login",
      loginImgUrl: require("../../assets/images/login/login.png"),
      logoUrl: require("../../assets/images/login/login_logo.png"),
      isElectron: window.isElectron,
      isH5: isH5(),
      inputAccountType: "Code",
    };
  },
  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect;
      },
      immediate: true,
    },
  },
  mounted() {
    this.$store.dispatch("user/getCountryCode");
  },
  methods: {
    changeLoginType(type) {
      this.loginType = type;
    },
    // 发送验证码成功
    sendCodeSuccess(type) {
      this.inputCodeType = type;
      this.step = "InputCode";
    },
    // 绑定账号
    goBindAccount() {
      this.step = "BindAccount";
    },
    // 从输入验证码界面返回
    goBack() {
      this.step = "InputAccount";
    },
    // 设置密码
    goSetPassword() {
      this.step = "InputPassword";
    },
    // 去登陆
    goLogin() {
      this.step = "InputAccount";
    },
    //
    goInputAccount(type) {
      this.inputAccountType = type;
      this.step = "InputAccount";
    },
    // 去选择身份
    goSelectIdentity() {
      this.step = "SelectIdentity";
    },
  },
};
</script>
<style lang="scss" scoped>
$bg: #2d3a4b;
$dark_gray: #889aa4;
$light_gray: #eee;

.login-container {
  height: 100vh;
  width: 100%;
  overflow: auto;
  display: flex;
  ::v-deep .el-input__inner {
    font-size: 16px;
    color: #0d1400 !important;
    /* 针对Webkit内核浏览器的特定前缀 */
    &::-webkit-input-placeholder {
      /* Chrome, Safari, Opera */
      color: #515350;
    }

    &:-moz-placeholder {
      /* Firefox 18- */
      color: #515350;
      opacity: 1; /* 修复Firefox 18-中的不透明度问题 */
    }

    &::-moz-placeholder {
      /* Firefox 19+ */
      color: #515350;
      opacity: 1; /* 修复Firefox 19+中的不透明度问题 */
    }

    &:-ms-input-placeholder {
      /* Internet Explorer 10-11 */
      color: #515350;
    }
  }
  .input-container {
    height: 100%;
    min-height: 550px;
    flex: 1;
    min-width: 580px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .logo-container {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .logo-box {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 360px;
      text-align: center;
      .login-main {
        width: 100%;
      }
      .login-logo {
        margin-top: 80px;
        width: 180px;
      }
      p {
        margin-top: 20px;
        font-size: 26px;
        font-weight: bolder;
      }
    }
  }
}
.login-container__web {
  height: 100%;
  width: 100%;
  overflow: auto;
  display: flex;
  .input-container {
    height: 100%;
    width: 480px;
    min-width: 480px;
  }
}
.login-container__h5 {
  height: 100%;
  width: 100%;
  overflow: auto;
  display: flex;
  ::v-deep .el-input__inner {
    font-size: 0.4267rem;
  }
  .input-container {
    height: 100%;
    min-height: 100%;
    width: 100%;
    min-width: 100%;
  }
}
@media (max-width: 1024px) {
  .logo-container {
    display: none !important;
  }
}
@media (min-width: 569px) and (max-width: 1024px) {
  // .logo-container {
  //     display: none;
  // }
}
</style>
